import PreviewTheme from '.';
import { RouteType } from '@/lib/route';

const PreviewThemeRoutes: RouteType = {
  path: '/preview-theme/:themeId/',
  component: PreviewTheme,
};

export interface PreviewThemeParamType {
  themeId: string;
}

export default PreviewThemeRoutes;
